export default "__VITE_ASSET__DdSaUPjj__"